module.exports = __webpack_public_path__ + "img/wheel_buyfeature_normal_info.b7f70350.png";